export default __webpack_public_path__ + "static/media/330_business01-fr-web.6cc82539.png";